import type { Role } from '../store/auth.ts';

// Pure mirror of backend/src/lib/body.ts so the UI gates identically.
export type Body = 'COUNCIL' | 'WDC';

export const BODIES: Body[] = ['COUNCIL', 'WDC'];

const COUNCIL_ELECTED: Role[] = ['PRESIDENT', 'VICE_PRESIDENT', 'MEMBER'];
const WDC_ELECTED: Role[] = ['WDC_PRESIDENT', 'WDC_VICE_PRESIDENT', 'WDC_MEMBER'];

// Office staff that service BOTH bodies. Order matters: it mirrors the legacy
// role-set ordering so council behaviour is byte-identical.
const SHARED_STAFF: Role[] = ['SECRETARY_GENERAL', 'BUREAU_STAFF'];

// The body an ELECTED role belongs to; null for shared staff / viewer / sysadmin.
export function bodyOfRole(role: Role): Body | null {
  if (COUNCIL_ELECTED.includes(role)) return 'COUNCIL';
  if (WDC_ELECTED.includes(role)) return 'WDC';
  return null;
}

export function presidentRole(body: Body): Role {
  return body === 'WDC' ? 'WDC_PRESIDENT' : 'PRESIDENT';
}

export function vicePresidentRole(body: Body): Role {
  return body === 'WDC' ? 'WDC_VICE_PRESIDENT' : 'VICE_PRESIDENT';
}

export function electedRoles(body: Body): Role[] {
  return body === 'WDC' ? [...WDC_ELECTED] : [...COUNCIL_ELECTED];
}

// Create a meeting: the body president + shared staff (SG, Bureau).
export function schedulerRoles(body: Body): Role[] {
  return [presidentRole(body), 'SECRETARY_GENERAL', 'BUREAU_STAFF'];
}

// Submit an agenda item: body president, vice, member + SG.
export function submitterRoles(body: Body): Role[] {
  return [presidentRole(body), vicePresidentRole(body),
    body === 'WDC' ? 'WDC_MEMBER' : 'MEMBER', 'SECRETARY_GENERAL'];
}

// Everyone who can appear on a body's meeting (members + shared staff), for
// attendance/signer pickers and document participant lists.
export function bodyParticipantRoles(body: Body): Role[] {
  return [...electedRoles(body), ...SHARED_STAFF];
}

// Write the yaumiyya: body elected + SG + Bureau.
export function writerRoles(body: Body): Role[] {
  return [...electedRoles(body), ...SHARED_STAFF];
}

// Approve/sign the yaumiyya: body voting members only (president, vice, member).
export function approverRoles(body: Body): Role[] {
  return [...electedRoles(body)];
}
